<footer>
    <div class="footer-v1 section-gap">
      <div class="container">
        <div class="footer-top-v1">
          <div fxLayout="row wrap" class="col-gap">
            <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="40" fxFlex.lg="40" fxFlex.xl="40">
              <h6>GEFINCAS</h6>
              <p>
                {{'SYSTEM.ABOUT_COMPANY_DESCRIPTION' | translate}}
              </p>
            </div>
          </div>
        </div>
        <!-- <hr>
        <div class="footer-bottom-v1">
          <div fxLayout='row wrap' class="col-gap">
            <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100" class="text-right">
              &copy; All Rights Reversed | {{ 'SYSTEM.MADE_BY' | translate }} Instituto Tecnológico de Galicia
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </footer>